import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-page-container',
	template: '',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'w-full h-full block  ',
	},
})
export class EmptyPageComponent {}
